// extracted by mini-css-extract-plugin
module.exports = {"embed":"_Embed_embed_2BL9w","spinner":"_Embed_spinner_3Xc7z"};